import { render, staticRenderFns } from "./ConfirmPurchase.vue?vue&type=template&id=3fd073d0&scoped=true&"
import script from "./ConfirmPurchase.vue?vue&type=script&lang=js&"
export * from "./ConfirmPurchase.vue?vue&type=script&lang=js&"
import style0 from "./ConfirmPurchase.vue?vue&type=style&index=0&id=3fd073d0&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3fd073d0",
  null
  
)

export default component.exports